import React, { useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Loader2, Mail, Phone } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;   // 10/14: was missing /api → every save hit the app host ("Not Found")

/**
 * 10/13 (Josh: "how will i know if there is an email missing or a phone number missing on that deal"):
 * compact inline fixer for a bounce row. `field` = "phone" | "email"; saves ONLY that field on the deal's
 * linked contact (POST /collections/deals/{deal}/contact-phone | contact-email), then calls onSaved.
 */
export default function ContactGapFix({ dealId, field, contactName, headers, onSaved }) {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const isPhone = field === 'phone';

  const save = async () => {
    if (!value.trim()) return;
    setSaving(true);
    try {
      await axios.post(`${API}/collections/deals/${dealId}/contact-${field}`, { [field]: value.trim() }, headers);
      toast.success(`${isPhone ? 'Phone' : 'Email'} saved on ${contactName || 'the contact'}`);
      setValue(''); setOpen(false);
      if (onSaved) await onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || `Could not save the ${field}`); }
    finally { setSaving(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)}
              className="inline-flex items-center gap-1 rounded border border-red-300 bg-red-50 px-1.5 py-0.5 text-[11px] font-medium text-red-700 hover:bg-red-100"
              title={`No ${field} on file for ${contactName || 'the contact'} — click to add`}>
        {isPhone ? <Phone className="h-3 w-3" /> : <Mail className="h-3 w-3" />} no {field} — add
      </button>
    );
  }
  return (
    <span className="inline-flex items-center gap-1">
      <Input className="h-7 w-44 text-xs bg-white" autoFocus placeholder={isPhone ? '(555) 555-5555' : 'owner@business.com'} value={value}
             onChange={e => setValue(e.target.value)}
             onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setOpen(false); }} />
      <Button size="sm" className="h-7 text-xs" disabled={saving || !value.trim()} onClick={save}>
        {saving ? <Loader2 className="h-3 w-3 animate-spin" /> : 'Save'}
      </Button>
      <button type="button" className="text-[11px] text-muted-foreground hover:underline" onClick={() => setOpen(false)}>cancel</button>
    </span>
  );
}
